import './bubbleTitle.css';

export default function BubbleTitle(title) {
    return(
        <div className="bubble-title-container">
            <div className="bubble-title">
                {title.title}
            </div>
        </div>
    )
}